import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { ToolbarGroup, ToolbarItem } from '@wordpress/components';

/**
 * Internal dependencies
 */
import BlockControls from '../block-controls';
import ImageEditingProvider from './context';
import Cropper from './cropper';
import ZoomDropdown from './zoom-dropdown';
import AspectRatioDropdown from './aspect-ratio-dropdown';
import RotationButton from './rotation-button';
import FormControls from './form-controls';
export default function ImageEditor({
  id,
  url,
  width,
  height,
  clientWidth,
  naturalHeight,
  naturalWidth,
  onSaveImage,
  onFinishEditing,
  borderProps
}) {
  return createElement(ImageEditingProvider, {
    id: id,
    url: url,
    naturalWidth: naturalWidth,
    naturalHeight: naturalHeight,
    onSaveImage: onSaveImage,
    onFinishEditing: onFinishEditing
  }, createElement(Cropper, {
    borderProps: borderProps,
    url: url,
    width: width,
    height: height,
    clientWidth: clientWidth,
    naturalHeight: naturalHeight,
    naturalWidth: naturalWidth
  }), createElement(BlockControls, null, createElement(ToolbarGroup, null, createElement(ZoomDropdown, null), createElement(ToolbarItem, null, toggleProps => createElement(AspectRatioDropdown, {
    toggleProps: toggleProps
  })), createElement(RotationButton, null)), createElement(ToolbarGroup, null, createElement(FormControls, null))));
}
//# sourceMappingURL=index.js.map